<template>
  <v-card-text class="py-6 px-6" v-if="mitigation !== undefined">
    <p class="text-h6 font-weight-light white--text">
      {{ mitigation.name }}
    </p>
    <p class="body-2 font-weight-light mb-0">
      {{ mitigation.description }}
    </p>
  </v-card-text>
</template>

<script>
export default {
  name: 'mitigationDetails',
  props: ['mitigation']
};
</script>
